import React from "react";

export default function DailyCheckConfirmModal({ isOpen, onClose, onConfirm }) {
    if (!isOpen) return null;

    return (
        <div
            className="modal fade show d-block"
            style={{ backgroundColor: "rgba(0, 0, 0, 0.5)", zIndex: 1060 }}
            tabIndex="-1"
        >
            <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "340px", margin: "0 auto", padding: "0 20px" }}>
                <div className="modal-content border-0 shadow" style={{ borderRadius: "16px" }}>

                    <div className="modal-body text-center pt-5 pb-4 px-4">
                        <div className="fw-bold text-dark mb-0 fs-16" style={{ lineHeight: "1.5" }}>
                            해당 날짜에 점검이력이 없습니다.<br />
                            점검표를 작성하시겠습니까?
                        </div>
                    </div>

                    <div className="d-flex gap-2 px-3 pb-4">
                        <button
                            type="button"
                            onClick={onClose}
                            className="btn btn-outline-light text-secondary border fw-bold w-100"
                            style={{ height: "44px", fontSize: "14px", borderColor: "#E0E0E0", borderRadius: "8px" }}
                        >
                            취소
                        </button>
                        <button
                            type="button"
                            onClick={onConfirm}
                            className="btn text-white fw-bold w-100"
                            style={{
                                height: "44px",
                                fontSize: "14px",
                                background: "#ff9d2f",
                                borderRadius: "8px"
                            }}
                        >
                            확인
                        </button>
                    </div>

                </div>
            </div>
        </div>
    );
}